import { addElementsToPlan } from "../api";

export const addElementToPlan = async (elementId, planId, columnId) => {
    await addElementsToPlan([elementId], planId, columnId, true);

    window.postMessage(
        JSON.stringify({
            messageName: "SendElementIdToCourseFeature",
            relatedEntityId: planId,
            customId: columnId
        }),
        "*"
    );
};
